import { EyeIcon } from "@heroicons/react/24/solid";
const ViewOHButton = ({
  buttonText = "",
  onClick,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={
        (disabled
          ? "cursor-not-allowed border text-VividBlue opacity-50 border-VividBlue"
          : "text-VividBlue border-VividBlue") +
        `${className} flex items-center place-content-center whitespace-nowrap hover:scale-90 transition duration-500
        bg-transparent border-VividBlue shadow-md hover:bg-VividBlue text-VividBlue group relative py-1 px-3 border
        text-xs font-medium rounded-full hover:text-white focus:outline-none hover:ring-2 focus:ring-offset-2
        hover:ring-VividBlue focus:ring-opacity-70`
      }
    >
      <EyeIcon className="h-4 w-4 mr-2" />
      <p className="font-semibold"> {buttonText}</p>
    </button>
  );
};
export default ViewOHButton;
